import { useState } from "react";
import { faqs, trustPoints } from "@/mocks/home";

export default function TrustFaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="w-full border-b border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <span className="font-label text-xs font-medium uppercase tracking-[0.3em] text-secondary-700">
              Why Tangdou
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              为什么放心在糖豆看
            </h2>
            <p className="mt-3 font-body text-sm leading-7 text-foreground-600 md:text-base">
              不绕弯子，四件事讲清楚：分类、更新、画质和门槛。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {trustPoints.map((point) => (
                <div
                  key={point.title}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-800">
                    <i className={`${point.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="mt-1.5 font-body text-sm leading-7 text-foreground-600">
                    {point.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-question-line text-sm"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                常见问题
              </h3>
            </div>

            <div className="mt-5 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {faqs.map((faq, index) => {
                const isOpen = openId === faq.id;
                return (
                  <div
                    key={faq.id}
                    className={index !== 0 ? "border-t border-background-200/80" : ""}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/60 md:px-6 md:py-5"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 md:px-6 md:pb-6">
                        <p className="font-body text-sm leading-7 text-foreground-600">{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}